import * as React from "react";
const Facebook = props => <symbol viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" d="M12 2a10 10 0 00-1.56 19.88v-7H7.9V12h2.54V9.8a3.52 3.52 0 013.77-3.89c.75.01 1.499.073 2.24.19v2.46h-1.26a1.45 1.45 0 00-1.63 1.56V12h2.78l-.45 2.89h-2.33v7A10 10 0 0012 2z" clipRule="evenodd" />
  </symbol>;
export default Facebook;